import React,{Component} from 'react';
import SliderBar from './SliderBar/SliderBar'





class App extends Component{
    render(){
        return(
            <SliderBar/>
        )
    }
}
export default App;


// WEBPACK FOOTER //
// ./src/Compent/App.js